module.exports = __webpack_public_path__ + "img/alert3.png";